const layers = {
  tooltip: 70,
  autoCompleteDropdown: 75,
  header: 90,
  aside: 100,
  floatActions: {
    button: 110,
    submit: 115,
  },
  popover: 120,
  toolbar: 130,
  offcanvas: 140,
  modals: 150,
  toast: 160,
} as const;

export default layers;
